import React, { useState, useEffect, useContext } from 'react';
import { Navbar, Button, Offcanvas, Form, FormControl, Container, Image, Nav } from 'react-bootstrap';
import { FaBars, FaHome, FaUser, FaCog, FaGraduationCap, FaMoneyBillWave,FaCalendar,FaBook,FaCar,FaScroll, FaUsers, FaBuilding, FaChartLine, FaCalendarAlt,FaCalendarCheck, FaChevronLeft } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { baseURL,imageUrl } from '../services/api';
import axios from 'axios';
import api from '../services/api';
import { pageTitles } from '../config/pageTitles';
import { AuthContext } from '../context/AuthContext';
import { stringToColor, getInitials } from '../utility';

const menuStyles = {
  menuContainer: {
    width: '280px',
    padding: '20px 0',
    backgroundColor: '#2c3e50',
    height: '100%',
    color: '#e4e6eb',
  },
  menuItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '12px 25px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    color: '#e4e6eb',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    textAlign: 'left',
    margin: '4px 15px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#fff',
      transform: 'translateX(5px)',
    },
  },
  menuItemActive: {
    backgroundColor: 'rgba(74, 144, 226, 0.15)',
    color: '#4a90e2',
    fontWeight: '500',
    borderLeft: '3px solid #4a90e2',
  },
  menuIcon: {
    fontSize: '18px',
    minWidth: '24px',
    marginRight: '12px',
    transition: 'all 0.2s ease',
  },
  menuText: {
    fontSize: '0.95rem',
    fontWeight: '400',
  },
  header: {
    padding: '15px 25px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    marginBottom: '15px',
  },
  closeBtn: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    color: '#e4e6eb',
    background: 'transparent',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    '&:hover': {
      color: '#fff',
    },
  },
};

function TopBar(props) {
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [logo, setLogo] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const { user } = useContext(AuthContext);
  // Get current page title and back button settings with support for parameterized routes
  const getPageConfig = (path) => {
    // First try exact match
    if (pageTitles[path]) return pageTitles[path];
    
    // Then try to match parameterized routes
    for (const [route, config] of Object.entries(pageTitles)) {
      if (route.includes(':')) {
        // Convert route to regex pattern
        const pattern = new RegExp(`^${route.replace(/:[^/]+/g, '([^/]+)')}$`);
        if (pattern.test(path)) {
          return config;
        }
      }
    }
    
    return { title: '', showBackButton: false };
  };
  
  const currentPageConfig = getPageConfig(location.pathname);
  const currentPageTitle = currentPageConfig.title;
  const showBackButton = currentPageConfig.showBackButton;
  // Handle back navigation
  const handleBack = () => {
    navigate(-1);
  };

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);
  
  const navigateAndClose = (path) => {
    navigate(path);
    handleClose();
  };

  useEffect(() => {
    // Check if logo is already in localStorage
    const storedLogo = localStorage.getItem('appLogo');
    if (storedLogo) {
      setLogo(storedLogo);
      return;
    }

    // Fetch logo from settings
    api.get(`/settings/logo`)
      .then(response => {
        setLogo(response.data.logo);
        localStorage.setItem('appLogo', response.data.logo);
      })
      .catch(error => {
        console.error('Error fetching logo:', error);
      });
  }, []);

  return (
    <div>
      {/* Offcanvas Sidebar for small screens */}
      <div className="d-lg-none">
        <Offcanvas 
          show={showSidebar} 
          onHide={handleClose} 
          placement="start"
          style={{ width: '280px' }}
        >
          <div style={menuStyles.menuContainer}>
            <div style={menuStyles.header}>
              <h5 style={{ color: '#fff', margin: 0 }}>Menu</h5>
              <button 
                onClick={handleClose} 
                style={menuStyles.closeBtn}
                aria-label="Close menu"
              >
                &times;
              </button>
            </div>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname === '/' && menuStyles.menuItemActive)
              }}
            >
              <FaHome style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Home</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/employees')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/employees') && menuStyles.menuItemActive)
              }}
            >
              <FaUser style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Employees</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/vehicles')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/vehicles') && menuStyles.menuItemActive)
              }}
            >
              <FaCar style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Vehicles</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/licenses')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/licenses') && menuStyles.menuItemActive)
              }}
            >
              <FaScroll style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Licenses</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/attendance')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/attendance') && menuStyles.menuItemActive)
              }}
            >
              <FaCalendar style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Attendance</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/monthly-summary')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/monthly-summary') && menuStyles.menuItemActive)
              }}
            >
              <FaCalendarCheck style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Monthly Summary</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/payroll')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/payroll') && menuStyles.menuItemActive)
              }}
            >
              <FaMoneyBillWave style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Payroll</span>
            </Button>

            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/app/appraisals')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/app/appraisals') && menuStyles.menuItemActive)
              }}
            >
              <FaChartLine style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Appraisals</span>
            </Button>
            
            <Button 
              variant="link" 
              onClick={() => navigateAndClose('/settings')}
              style={{
                ...menuStyles.menuItem,
                ...(location.pathname.startsWith('/settings') && menuStyles.menuItemActive)
              }}
            >
              <FaCog style={menuStyles.menuIcon} /> 
              <span style={menuStyles.menuText}>Settings</span>
            </Button>
          </div>
        </Offcanvas>
      </div>

      {/* Top Navbar */}
      <Navbar  expand="lg" className="px-3 shadow-sm" style={{ height: '60px', width: '100%'}}>
        <Container fluid className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            {/* Sidebar Toggle for small screens */}
            <Button variant="light" className="d-lg-none me-2" onClick={handleShow}>
              <FaBars />
            </Button>
            <div className="d-flex align-items-center">
              {/* Back button based on configuration */}
              {showBackButton && (
                <Button
                  variant="outline-secondary"
                  className="d-flex align-items-center me-3 border-0 bg-white shadow-sm"
                  onClick={handleBack}
                  style={{
                    padding: '0.4rem 1rem',
                    borderRadius: '6px',
                    transition: 'all 0.2s ease',
                    color: '#495057',
                    fontWeight: '500',
                    ':hover': {
                      backgroundColor: '#f8f9fa',
                      transform: 'translateX(-2px)'
                    }
                  }}
                >
                  <FaChevronLeft size={14} className="me-2" style={{ marginTop: '-1px' }} />
                  <span>Back</span>
                </Button>
              )}

              {/* Page Title */}
              <div className="d-flex flex-column">
                <h4 className="mb-0" style={{ 
                  color: '#212529', 
                  fontWeight: '600',
                  fontSize: '1.25rem',
                  lineHeight: '1.5'
                }}>
                  {currentPageTitle}
                </h4>
                {/* <small className="text-muted" style={{ fontSize: '0.85rem' }}>
                  {new Date().toLocaleDateString('en-US', { 
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric' 
                  })}
                </small> */}
              </div>
            </div>
          </div>

          {/* Right-aligned Username */}
          <div className="d-flex align-items-center gap-3">
            {props.children}
            {user && (
              <div className="d-flex align-items-center gap-2">
                {user.profile_image ? (
                  <img
                    src={`${imageUrl}/${user.profile_image}`}
                    alt="Profile"
                    className="rounded-circle"
                    style={{ width: 36, height: 36, objectFit: 'cover', border: '2px solid #eee' }}
                  />
                ) : (
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: 36,
                      height: 36,
                      backgroundColor: stringToColor(user.name || user.email),
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '1rem',
                      userSelect: 'none',
                    }}
                  >
                    {getInitials(user.name || user.email)}
                  </div>
                )}
                <span style={{ fontWeight: 500, color: '#333', fontSize: '1rem' }}>
                  {user.name || user.email}
                </span>
              </div>
            )}
          </div>
        </Container>
      </Navbar>
    </div>
  );
}

export default TopBar;
